import { Component, EventEmitter, Input, Output, OnInit, inject, DestroyRef } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ViewUpdateResultsComponent } from 'src/app/main/service/view-update-results/view-update-results.component';
import { Configuration } from 'src/app/models/configuration';
import { ConfigurationApplicationStatus, ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { Instance } from 'src/app/models/instance/instance';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { DeploymentClass } from '../../../models/instance-class';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { DataZone } from 'src/app/models/data-zone/data-zone';


const REQUIRED_PERMISSIONS = [
  Permission.RETRY,
  Permission.APPLY_RELEASE_PACKAGE_HOTFIX,
  Permission.APPLY_RELEASE_PACKAGE_TILL_TEST
];

@Component({
    selector: 'app-configuration-state',
    templateUrl: './configuration-state.component.html',
    styleUrls: ['./configuration-state.component.scss'],
    standalone: false
})
export class ConfigurationStateComponent implements OnInit  {

  @Input() instance: Instance;
  @Input() configurations: Configuration[];
  @Input() configurationState: ConfigurationState;
  @Input() configStateMessageExpireTime;
  @Input() configStateVerify;
  @Input() instanceConfigStatus;
  @Input() configLastRecord;
  @Output() retry = new EventEmitter();
private destroyRef = inject(DestroyRef);
  isCompleted: boolean;

  ConfigurationApplicationStatus = ConfigurationApplicationStatus;
  DataZone = DataZone;

  STEPS: any;
  currentInstanceRecord: any;
  deploymentClass = DeploymentClass;
  permissionsMap: {[key: string]: boolean};

  constructor(private sidenavService: SidenavService, private permissionsService: PermissionsService) {
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    if (this.configurationState.status !== ConfigurationApplicationStatus.VERIFIED && (!this.configStateVerify)) {
      this.STEPS = [{
        activeStates: [undefined, null, ConfigurationApplicationStatus.CONFIGURING],
        completedStates: [ConfigurationApplicationStatus.CONFIGURED, ConfigurationApplicationStatus.TESTING,
          ConfigurationApplicationStatus.SUCCESS, ConfigurationApplicationStatus.TEST_FAILED,
          ConfigurationApplicationStatus.CONFIGURE_FAILED],
        text: 'CONFIGURATIONS.STATE.APPLYING_CONFIGURATION'
      }, {
        activeStates: [ConfigurationApplicationStatus.CONFIGURED, ConfigurationApplicationStatus.TESTING],
        completedStates: [ConfigurationApplicationStatus.SUCCESS, ConfigurationApplicationStatus.TEST_FAILED,
          ConfigurationApplicationStatus.CONFIGURE_FAILED, ConfigurationApplicationStatus.VERIFIED,
          ConfigurationApplicationStatus.VERIFY_CONFIGURED_FAILED],
        text: 'CONFIGURATIONS.STATE.TESTING_UPDATE'
      }];
    } else {
      this.STEPS = [{
        activeStates: [ConfigurationApplicationStatus.VERIFY_CONFIGURED, ConfigurationApplicationStatus.VERIFY_TESTING],
        completedStates: [ConfigurationApplicationStatus.VERIFIED, ConfigurationApplicationStatus.VERIFICATION_FAILED,
          ConfigurationApplicationStatus.SUCCESS],
        text: 'CONFIGURATIONS.STATE.VERIFY_DEPLOYING'
      }];
      this.configStateVerify = true;
    }

    this.currentInstanceRecord = this.configLastRecord.filter(item => item.instanceId === this.instance.id).reverse()[0];
  }

  viewUpdateResults(event): void {
    event.stopPropagation();
    const data = {
      title: translate('CONFIGURATIONS.STATE.VIEW_RESULTS'),
      subtitle: this.instance.environment,
      configurationStates: this.instance.configurationStates,
      configurations: this.configurations
    };

    this.sidenavService.openInRightSidenav(ViewUpdateResultsComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  doRetry(event): void {
    event.stopPropagation();
    this.retry.emit({instanceId: this.instance.id, configurationId: this.configurationState.configurationId,
      configurations: this.configurations});
  }
}
